module.exports = __webpack_public_path__ + "img/lamomo_led_strip_2m.652d2ccb.png";